<template>
    <div class="row py-2">
        <!--Breaking box-->
        <div class="col-1 col-md-3 col-lg-2 py-1 pr-md-0 mb-md-1">
            <div class="d-inline-block d-md-block bg-primary text-white text-center breaking-caret py-1 px-2">
                <span class="fas fa-bolt" title="Breaking News"></span>
                <span class="d-none d-md-inline-block">Pengumuman</span>
            </div>
        </div>
        <!--Breaking content-->
        <div class="col-11 col-md-9 col-lg-10 pl-1 pl-md-2">
            <div class="breaking-box pt-2 pb-1">

                <div id="app">
                    <div class="scrolling-container">
                        <div class="scrolling-wrapper">
                            <div v-for="news in newsList" :key="news.id" class="scroll-item">
                                <router-link :to="`/pengumuman/${news.id}`" class="h6 font-weight-light">{{ news.titel }}</router-link>
                                <!-- <a class="h6 font-weight-light"
                                    href="https://bootstrap.news/bootstrap-4-template-news-portal-magazine/"><span
                                        class="position-relative mx-2 badge badge-primary rounded-0">Technology</span>
                                    {{ news.titel }}
                                </a> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "BeritaTerkini",
    data() {
        return {
            newsList: [],
            loading: true,
            error: null,
        };
    },
    methods: {
        async fetchNews() {
            try {
                const response = await axios.get(
                    "/content/pengumuman?pages=1&limit=3"
                );
                this.newsList = response.data.data;
                // console.log(response.data)
            } catch (err) {
                this.error = "Gagal memuat berita. Coba lagi nanti.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("id-ID", options);
        },
    },
    created() {
        this.fetchNews();
    },
};
</script>

<style>
.scrolling-container {
    width: 100%;
    overflow: hidden;
    /* Sembunyikan teks di luar container */
    white-space: nowrap;
    /* Pastikan item tidak pindah baris */
}

.scrolling-container:hover .scrolling-wrapper {
    animation-play-state: paused;
}

.scrolling-wrapper {
    display: inline-block;
    /* Agar bisa digulir */
    animation: marquee 30s linear infinite;
    /* Atur durasi dan repetisi */
}

.scroll-item {
    display: inline-block;
    /* Tampilkan sebagai satu baris */
    margin-right: 20px;
    /* Jarak antar item */
}

@keyframes marquee {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }

    /* Geser ke kiri hingga habis */
}
</style>